import transformServiceType from './transform-service-type';

/**
 * Fetches a tab of data from the middleware based on a tab name.
 * @param {string} tabName - The tab name to fetch.
 * @returns {Promise} A Promise that resolves to JSON data.
 */
const fetchTab = async (tabName) => {
  const response = await fetch(`/wp-json/hst/v1/google-sheets-tab?tab=${tabName}`);
  const rawData = await response.json();
  return transformServiceType(rawData);
};

export default fetchTab;
